import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpKeyboardHints = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V14C23.5 15.933 21.933 17.5 20 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4C0.5 2.067 2.067 0.5 4 0.5Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V14C23.5 15.933 21.933 17.5 20 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4C0.5 2.067 2.067 0.5 4 0.5Z",
			stroke: "#D9D9D9",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.408 11.3335L9.59186 11.3335C9.4474 11.3335 9.36674 11.1046 9.4562 10.9483L11.8643 6.75681C11.9332 6.63684 12.0659 6.63684 12.1356 6.75681L14.5437 10.9483C14.6332 11.1046 14.5525 11.3335 14.408 11.3335Z",
			fill: "#434343"
		})
	]
});
const ForwardRef = forwardRef(SvgUpKeyboardHints);
export { ForwardRef as ReactComponent };
